export const USER_INPUT_GETALL_COLUMNS_TYPE_REQUEST = 'USER_INPUT_GETALL_COLUMNS_TYPE_REQUEST';
export const USER_INPUT_GETALL_COLUMNS_TYPE_SUCCESS = 'USER_INPUT_GETALL_COLUMNS_TYPE_SUCCESS';
export const USER_INPUT_GETALL_COLUMNS_TYPE_FAIL = 'USER_INPUT_GETALL_COLUMNS_TYPE_FAIL';

